<app-dea-widget-wrapper>
  <div class="row m-0 p-0">
    <div class="col m-0 p-0">
      <app-dea-search-bar (text)="onText($event)"></app-dea-search-bar>
    </div>
    <div class="col-auto m-0 p-0 ms-2" title="DISABILITATO">
      <button mat-flat-button color="primary" [disabled]="true" class="fw-bold px-3 py-1 rounded-pill">
        Scarica CSV
      </button>
    </div>
  </div>
  <!-- FILTERS -->
  <div class="mt-2">
    <form [formGroup]="filterForm" class="d-flex flex-column gap-1">
      <div class="d-flex flex-row gap-4 align-items-center">
        <mat-radio-group formControlName="period" class="d-flex flex-row gap-2 align-items-start" color="primary">
          <mat-radio-button value="school_year">Anno Scolastico</mat-radio-button>
          <mat-radio-button value="range">Periodo</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="filterForm.get('period')?.value === 'school_year'">
          <select class="form-control dea-form-input" formControlName="school_year">
            <option *ngFor="let schoolYear of schoolYears$ | async;" [value]="schoolYear">
              {{schoolYear}}
            </option>
          </select>
        </div>
        <div *ngIf="filterForm.get('period')?.value === 'range'" class="d-flex gap-2">
          <input type="date" formControlName="from" class="form-control dea-form-input" />
          <input type="date" formControlName="to" class="form-control dea-form-input" />
        </div>
        <select formControlName="types">
          <option value="*">Tutto</option>
          <option *ngFor="let o of typesOptions;" [value]="o.value">{{o.label}}</option>
        </select>
      </div>
    </form>
  </div>
  <!-- FILTERS -->
  <div class="v-spacer"></div>
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && error" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    {{error.message}}
  </div>
  <div *ngIf="!loading && !error" class="m-0 p-0">
    <div *ngFor="let tech of this.techs;" class="mb-3 flex flex-column gap-3 w-full">
      <div class="w-full p-4 ps-2 pb-2 border rounded">
        <app-user-device-box [device]="tech.device"></app-user-device-box>
        <div class="mt-2" style="margin-left: 54px !important; border-left: 3px solid rgba(0, 0, 0, .2);">
          <div *ngFor="let doc of tech.docs;">
            <div class="row m-0 p-0 mb-2">
              <div class="col m-0 p-0" style="max-width: 180px;">
                <div class="ps-2 fw-semibold">
                  {{this.getTechBlockLabel(doc.__type)}}
                </div>
              </div>
              <div class="col m-0 p-0 fw-thin" style="max-width: 250px;">
                {{doc.createdAt | toItDateDdMmmmYyyy}}
              </div>
              <div class="col m-0 p-0 cursor-pointer" [title]="'Visualizza ' + doc.owner?.getFullName()"
                [routerLink]="'/utente/'+doc.owner?.id">
                <span class="opacity-50">{{doc.owner?.dea_id}}</span> {{doc.owner?.getFullName()}}
              </div>
              <div class="col-auto m-0 p-0 text-end">
                <span class="opacity-50">A.S.</span> {{doc.anno_scolastico}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="v-spacer"></div>
  <app-listing-pagination-bar [paginationData]="pagination" (pageEmitter)="onPage($event)"></app-listing-pagination-bar>
</app-dea-widget-wrapper>